//Components and such should use the first item in the array as the default
const bootstrapButtonStyleClasses = [
	'btn-primary',
	'btn-secondary',
	'btn-success',
	'btn-danger',
	'btn-warning',
	'btn-info',
	'btn-light',
	'btn-dark',
	'btn-link',
	'btn-outline-primary',
	'btn-outline-secondary',
	'btn-outline-success',
	'btn-outline-danger',
	'btn-outline-warning',
	'btn-outline-info',
	'btn-outline-light',
	'btn-outline-dark',
]

const breakpoints = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
]

const getBootstrapBreakpoint = () => {
	const windowWidth = window.innerWidth

	if (windowWidth >= 1200) {
		return 'xl'
	} else if (windowWidth >= 992) {
		return 'lg'
	} else if (windowWidth >= 768) {
		return 'md'
	} else if (windowWidth >= 576) {
		return 'sm'
	} else if (windowWidth < 576) {
		return 'xs'
	}
}

module.exports = {
	bootstrapButtonStyleClasses,
	getBootstrapBreakpoint,
}